<template>
  <div class="zp-auth d-flex flex-column">
    <div class="header">
      <a href="https://zaper.in">
        <img src="/img/logo.svg" alt="Logo">
      </a>
    </div>
    <div class="flex-grow-1 d-flex justify-center align-center">
      <div class="row" style="max-width: 750px; width: 100%;">
        <div class="col-md-6 col-xs-12 d-flex flex-column pa-10 pl-10 pr-10">
          <h1 class="font-weight-bold hidden-mobile" style="color: #21C59E; font-size: 4em; line-height: 1.1">
            Seu link ficará assim
          </h1>
          <h1 class="font-weight-bold hidden" style="color: #21C59E; font-size: 3em; line-height: 1.1">
            Falta pouco!
          </h1>
          <div class="flex-grow-1 d-flex flex-column justify-end" style="margin-top: 40px">
            Para criar e salvar seu primeiro link, basta acessar com sua conta Facebook ou Google. Bora lá!
          </div>
          <div class="d-flex flex-column align-center">
            <v-btn color="red darken-1" id="btn-google" large depressed class="mt-5" @click="google()" dark block>
              <v-icon class="mr-1">mdi-google</v-icon> <span>Entrar com o Google</span>
            </v-btn>
            <v-btn color="primary" large class="mt-5" depressed @click="facebook()" :loading="loading.facebook" block>
              <v-icon class="mr-1">mdi-facebook</v-icon> <span>Entrar com o Facebook</span>
            </v-btn>
            <a target="_blank" class="mt-5 blue--text" style="font-size: .8em; text-decoration: none;" href="https://zaper.in/gerenciador-de-links-termos-de-uso">Termos de uso e privacidade</a>
          </div>
        </div>
        <div class="col-md-6 col-xs-12 d-sm-none d-md-flex hidden-mobile">
          <zp-mobile-device v-model="link"></zp-mobile-device>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { nanoid } from 'nanoid'
import ZpMobileDevice from '@/components/MobileDevice.vue'

export default {
  components: {
    ZpMobileDevice
  },
  data () {
    return {
      loading: {},
      link: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters({
      project: 'projects/getSelected'
    })
  },
  mounted () {
    if (!this.$route.query.title || !this.$route.query.url || !this.$route.query.description) {
      return window.location.href = 'https://zaper.in'
    }

    this.link = {
      mode: 'preview',
      shortened: nanoid(6),
      name: 'Meu link',
      title: this.$route.query.title,
      url: this.$route.query.url,
      description: this.$route.query.description
    }

    if (this.$route.query.utm_source) {
      localStorage.setItem('utm_source', true)
    }

    if (this.user) {
      this.$router.push('/links')
    }
  },
  methods: {
    setLoading (name, value) {
      this.loading = {
        ...this.loading,
        [name]: value
      }
    },
    async facebook () {
      this.setLoading('facebook', true)
      try {
        const data = await this.$store.dispatch('auth/login', { type: 'facebook', utm_source: this.$route.query.utm_source || '' })
        this.to(data)
      } catch (e) {
        console.error(e)
      }
      this.setLoading('facebook', false)
    },
    async google () {
      this.setLoading('google', true)
      try {
        const data = await this.$store.dispatch('auth/login', { type: 'google', utm_source: this.$route.query.utm_source || '' })
        this.to(data)
      } catch (e) {
        console.error(e)
      }
      this.setLoading('google', false)
    },
    to (data) {
      this.$store.commit('links/SET_PREVIEW', this.link)

      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect)
      } else if (data.registered) {
        this.$router.push('/aprender-e-praticar')
      } else {
        this.$router.push('/links')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.zp-auth {
  color: #000;
  background-color: #F8FAFB;

  .header {
    padding-bottom: 15px;
    padding-left: 15px;
    padding-top: 15px;

    img {
      height: 40px;
    }
  }
}

.green--text {
  color: #21c59e;
}

@media only screen and (min-width: 920px) {
  .hidden {
    display: none;
  }
}

@media only screen and (max-width: 920px) {
  .hidden-mobile {
    display: none;
  }
}
</style>